import React, { Component } from "react";
import axios from "axios";
import moment from "moment";
import domain from ".././../../../domain";
import { Row, Col, Card, CardBody } from "mdbreact";
export default class AddCourse extends Component {
  constructor(props) {
    super(props);
    this.state = {
      coursetitle: "",
      year: "",
      coursecat: "",
      courseid: "",
      startdate: "",
      enddate: "",
    };
  }

  courseTitleRef = React.createRef();
  yearRef = React.createRef();
  courseIDRef = React.createRef();
  startDateRef = React.createRef();
  endDateRef = React.createRef();
  courseCatRef = React.createRef();
  createCourse = (event) => {
    event.preventDefault();
    const startdate = this.startDateRef.current.value;
    const enddate = this.endDateRef.current.value;
    let end = moment(enddate);
    let start = moment(startdate);
    let difference = end.diff(start, "days");
    if (difference === 0) {
      alert("You selected Same Dates");
      return false;
    } else if (difference < 0) {
      alert("You selected Wrong dates");
      return false;
    }
    console.log(end + start);
    const course = {
      coursetitle: this.courseTitleRef.current.value,
      year: this.yearRef.current.value,
      coursecat: this.courseCatRef.current.value,
      courseid: this.courseIDRef.current.value,
      startdate: this.startDateRef.current.value,
      enddate: this.endDateRef.current.value,
    };
    let r = window.confirm("Check once again the details before submitting");
    if (r) {
      this.insertCourse(course);
    } else {
      return false;
    }
  };

  insertCourse(course) {
    axios({
      method: "post",
      url: `${domain.DBServer}/add-course`,
      data: course,
      //config: { headers: {'Content-Type': 'multipart/form-data' }}
    })
      .then((response) => {
        //console.log(response)
        const { err, success, msg } = response.data;

        //console.log(success+msg+err)
        console.log(success);
        console.log(err);

        if (success) {
          console.log("if");
          alert(msg);
          //console.log(this)
          this.props.history.replace("/view-courses");
        } else {
          console.log("else");
          alert(msg);
        }
      })
      .catch((response) => {
        console.log(response);
      });
  }
  intialValues = (e) => {
    alert(e.target.name);
    this.setState({
      coursetitle: "",
      year: "",
      coursecat: "",
      courseid: "",
      startdate: "",
      enddate: "",
    });
  };

  render() {
    return (
      <Row className="justify-content-md-center">
        <Col md="6">
          <Card>
            <CardBody>
              <h1 style={{ textAlign: "center", color: "blue" }}>
                Add New Course
              </h1>
              {/* <Link className="btn grey" to="/Home">Back</Link> */}
              <form onSubmit={this.createCourse}>
                <div className="form-group-sm row">
                  <label className="mr-sm-2">Year</label>
                  <select
                    className="custom-select mr-sm-2"
                    ref={this.yearRef}
                    required
                  >
                    {/* <option selected>Choose...</option> */}
                    <option value="2017-18">2017-18</option>
                    <option value="2018-19">2018-19</option>
                    <option value="2019-20">2019-20</option>
                    <option value="2020-21">2020-21</option>
                    <option value="2021-22">2021-22</option>
                    <option value="2022-23">2022-23</option>
                    <option value="2023-24">2023-24</option>
                  </select>
                </div>
                <div className="form-group-sm row">
                  <label className="mr-sm-2">Course Category</label>
                  <select
                    className="custom-select mr-sm-2"
                    ref={this.courseCatRef}
                  >
                    {/* <option selected>Choose...</option> */}
                    <option value="1">One-Week</option>
                    <option value="2">Two-week</option>
                    <option value="3">Customized</option>
                  </select>
                </div>
                <div className="form-group-sm row">
                  <label className="col-sm-2 col-form-label col-form-label-sm">
                    Course Title
                  </label>
                  <input
                    className="form-control"
                    name="course-title"
                    type="text"
                    ref={this.courseTitleRef}
                    placeholder="Title of the course"
                    required
                    autoFocus
                  />
                  <div className="valid-tooltip">Looks good!</div>
                </div>
                <div className="form-group-sm row">
                  <label className="col-sm-2 col-form-label col-form-label-sm">
                    Course ID
                  </label>
                  <input
                    className="form-control"
                    name="course-id"
                    type="text"
                    ref={this.courseIDRef}
                    placeholder="Course Id"
                    required
                  />
                </div>
                <div className="form-group-sm row">
                  <label className="col-sm-2 col-form-label col-form-label-sm">
                    Start Date
                  </label>
                  <input
                    className="form-control"
                    name="startDate"
                    type="date"
                    ref={this.startDateRef}
                    placeholder="Start Date"
                    required
                  />
                </div>
                <div className="form-group-sm row">
                  <label className="col-sm-2 col-form-label col-form-label-sm">
                    End Date
                  </label>
                  <input
                    className="form-control"
                    name="endDate"
                    type="date"
                    ref={this.endDateRef}
                    placeholder="End Date"
                    required
                  />
                </div>
                <button type="submit" className="btn btn-primary">
                  Submit
                </button>
                &nbsp;&nbsp;
                <button
                  type="reset"
                  className="btn btn-primary"
                  name="clear"
                  onClick={this.intialValues}
                >
                  Clear
                </button>
              </form>
            </CardBody>
          </Card>
        </Col>
      </Row>
    );
  }
}
